import { SxProps, Theme, Tooltip, SvgIcon } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { Link } from 'react-router-dom';
import { NoAuthRouteKeys } from 'src/utils/constants/routes';

const TooltipTradeDataLimit = ({ sxIcon = {}, icon }: { sxIcon?: SxProps<Theme>; icon?: JSX.Element }) => {
  return (
    <Tooltip
      arrow
      placement="top"
      title={
        <>
          There are some countries that refuse to provide this data. Please read more about{' '}
          <Link
            style={{ color: '#fff', textDecoration: 'underline' }}
            onClick={(event) => {
              event.stopPropagation();
            }}
            to={NoAuthRouteKeys.TradeDataLimitations}
          >
            data provision limitations.
          </Link>
        </>
      }
    >
      {icon || <InfoOutlinedIcon color="action" sx={{ fontSize: 16, ...sxIcon }} />}
    </Tooltip>
  );
};

export default TooltipTradeDataLimit;
